function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 5.52273C0.5 5.93694 0.835786 6.27273 1.25 6.27273C1.66421 6.27273 2 5.93694 2 5.52273L2 2.56066L9.93934 10.5H6.97727C6.56306 10.5 6.22727 10.8358 6.22727 11.25C6.22727 11.6642 6.56306 12 6.97727 12H11.65C12.1194 12 12.5 11.6194 12.5 11.15V6.47727C12.5 6.06306 12.1642 5.72727 11.75 5.72727C11.3358 5.72727 11 6.06306 11 6.47727V9.43934L3.06066 1.5H6.02273C6.43694 1.5 6.77273 1.16421 6.77273 0.75C6.77273 0.335787 6.43694 0 6.02273 0H1.35C0.880557 0 0.5 0.380559 0.5 0.85L0.5 5.52273Z",
  fill: "black",
  fillOpacity: 0.6
});

function SvgResizer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizer);
export default __webpack_public_path__ + "static/media/resizer.48aab032.svg";
export { ForwardRef as ReactComponent };